<template>
    <div class="comment">
        <div class="head-title">精彩评论 ({{commentData.length}})</div>
        <div class="comment-template" v-for="(li, index) in commentData" :key="index">
            <img class="head-img"  :src="li.comment_user.avatar" />
            <div class="user-name">{{li.comment_user.name}}</div>
            <div class="date">{{dateFormat(li.created_at + '000', 'yyyy/MM/d')}}</div>
            <div class="comment-content">{{li.comment_content}}</div>
            <div class="like-count" @click="toDownload">
                <div class="count">{{li.comment_praise}}</div>
                <!-- <img src="../assets/awesome_active.png" class="like-icon"/> -->
                <img src="../assets/awesome_default.png" class="like-icon"/>
            </div>
        </div>
        <div class="nothing" v-if="commentData.length === 0">暂无评论</div>
        <div class="bottom-button" style="opacity: 0;">查看全部评论</div> <!--  @click="toDownload" -->
    </div>
</template>

<script>
export default {
  name: 'comment',
  props: {
    commentData: Array
  },
  data () {
    return {

    }
  },
  methods: {
    toDownload () {
      // this.$parent.openA()
    },
    dateFormat (date, format) { // yy:mm:ss //这样都行 yyyy年mmmm分sss秒
      date = parseInt(date)
      if (!format || typeof format !== 'string') {
        console.error('format is undefiend or type is Error')
        return ''
      }

      date = date instanceof Date ? date : (typeof date === 'number' || typeof date === 'string') ? new Date(date) : new Date()

      // 解析
      let formatReg = {
        'y+': date.getFullYear(),
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      }
      for (let reg in formatReg) {
        if (new RegExp(reg).test(format)) {
          let match = RegExp.lastMatch // 上一次的匹配到的字符串
          format = format.replace(match, formatReg[reg] < 10 ? '0' + formatReg[reg] : formatReg[reg].toString())
        }
      }
      return format
    }
  },
  mounted () {
    setTimeout(() => {
      console.log(this.commentData)
    }, 1000)
  }
}
</script>

<style lang="scss" scoped>
.comment {
    width: 100%;
    padding-bottom: px2html(100px);
    position:relative;
    top:px2html(-125px);
    .head-title {
        display: flex;
        align-items: center;
        color: rgba(154, 129, 117, 1);
        font-size: px2html(14px);
        height: px2html(45px);
        text-align: left;
        box-sizing: border-box;
        padding-left: px2html(25px);
        background-color: #fff;
    }
    .nothing {
        font-size: px2html(14px);
        color: rgba(87, 49, 30, 0.6);
        background-color: #fff;
        padding-bottom: px2html(10px);
    }
    .comment-template {
        background-color: rgba(255, 255, 252, 1);
        min-height: px2html(99px);
        width: 100%;
        position: relative;
        .head-img {
            width: px2html(35px);
            height: px2html(35px);
            border-radius: 50%;
            position: absolute;
            left: px2html(25px);
            top: px2html(14px);
        }
        .user-name {
            position: absolute;
            left: px2html(69px);
            top: px2html(15px);
            color: rgba(87, 49, 30, 0.4);
            font-size: px2html(14px);
            height: px2html(14px);
        }
        .date {
            position: absolute;
            top: px2html(35px);
            left: px2html(70px);
            height: px2html(12px);
            color: rgba(87, 49, 30, 0.2);
            font-size: px2html(12px);
        }
        .comment-content {
            text-align: justify;
            width: px2html(281px);
            position: relative;
            padding-top: px2html(54px);
            color: rgba(87, 49, 30, 0.6);
            font-size: px2html(14px);
            left: px2html(70px);
        }
        .like-count {
            position: absolute;
            right: px2html(25px);
            top: px2html(30px);
            display: flex;
            align-items: center;
            .count {
                position: relative;
                left: px2html(-5px);
                color: rgba(87, 49, 30, 0.2);
                font-size: px2html(12px);
            }
            .like-icon {
                position: relative;
                top: px2html(-1px);
                width: px2html(20px);
                opacity: .2;
            }
        }
    }
    .bottom-button {
        position: relative;
        left: 50%;
        top: px2html(15px);
        transform: translateX(-50%);
        color: rgba(87, 49, 30, 0.6);
        width: px2html(118px);
        height: px2html(30px);
        font-size: px2html(14px);
        border-radius: px2html(15px);
        border: px2html(1px) rgba(87, 49, 30, 0.6) solid;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>
